module.exports = "https://img1.zhuanstatic.com/platform/zz-universal-pages/static/img/books.b9e5b37e.png";